__turbopack_context__.v({
  "book-review-nl-info": "BookReview-module__VNwava__book-review-nl-info",
  "book-review-page": "BookReview-module__VNwava__book-review-page",
  "book-review-page-feedback-title": "BookReview-module__VNwava__book-review-page-feedback-title",
  "book-review-page-search": "BookReview-module__VNwava__book-review-page-search",
  "book-review-page-search-title": "BookReview-module__VNwava__book-review-page-search-title",
  "book-review-page-title": "BookReview-module__VNwava__book-review-page-title",
  "book-review-page-title-hidden": "BookReview-module__VNwava__book-review-page-title-hidden",
  "feedback-button": "BookReview-module__VNwava__feedback-button",
  "feedback__buttons": "BookReview-module__VNwava__feedback__buttons",
  "ldl-book-review-newsletter": "BookReview-module__VNwava__ldl-book-review-newsletter",
  "selected-book-author": "BookReview-module__VNwava__selected-book-author",
  "selected-book-container": "BookReview-module__VNwava__selected-book-container",
  "selected-book-label": "BookReview-module__VNwava__selected-book-label",
});
